export const Text = {
  loginHeader: "Welcome Back",
  loginSubHeader: "Enter your email and password below",
  loginEmailPlaceholder: "Enter email",
  loginPasswordPlaceholder: "Enter pin",
  loginEnterEmail: "Please enter the email id",
  loginEnterPassword: "Please enter the pin",
  loginEntername: "Please enter the name",
  loginEnterphone: "Please enter the Phone number",
  loginInvalidEmail: "Invalid email id",
  loginButtonLabel: "Login",
  loginForgotPassword: "Forgot Pin?",
  noAccount: "No account?",
  signUpSubHeader: "Signup for the Best Experience at AL Maha",
  signUp: "Sign up",
  signUpName: "Enter Name",
  signUpNo: "Enter Mobile Number",
  signUpConfirmPassword: "ReEnter Password",
  signUpHeader: "Welcome to AL MAHA",
  signUpEnterCaptcha: "Please enter the captcha",
  haveAccount: "Have an account?",
  signIn: "Sign in",
  guestHeader: "Guest Checkout",
  guestSubHeader: "Continue to Checkout without an account",
  otpHeader: "Enter the OTP",
  otpSubHeader: "Enter the 4-digit code we have sent to your Mobile ",
  otpInput: "Please enter the OTP",
  recieveCode: "Didn’t receive the code?",
  resendCode: "Re-send code",
  verifyOtpHeader: "Create a four digit PIN",
  verifyOtpSubHeader: "Enter the 4-digit code we have sent to your Mobile ",
  customerReview: "5 Customer Review",
  addPromoCode: "Add Promo Code",
  enterPromoCode: "Enter your Promo code if you have one",
  enterPromoCodeNote: "For more offers Download AL Maha Mobile App",
  applyCoupon: "Apply Promo",
  continueShopping: "Continue Shopping",
  termsConditions: "Terms & Conditions",
  privacy: "Privacy Policy",
  myCart: "My Cart",
  myPurchases: "My Purchases",
  entertainmentPark: "Entertainment Park",
  contactUs: "Contact Us",
  downloadApp: "Download Our App",
  discount: "for discounts and offers",
  popularCategory: "Popular Categories",
  footerText:
    "Copyright © 2023. All rights reserved by Al Maha. | - Powered by PIH",
  subTotal: "Sub Total",
  saving: "Saving",
  grandTotal: "Grand Total",
  qar: "QAR",
  proceedToCheckout: "Proceed to Checkout",
  productDetails: "Product Details",
  price: "Price",
  quantity: "Quantity",
  landingWelcomeText: "Introducing a New, Easy Way to Plan Your Visit to",
  landingWelcomeText2: "Our Entertainment Parks",
  landingInfoText:
    "You now have the opportunity to purchase theme park tickets and make required theme park reservations at the same time.",
  landingBannerTitle: "Countless Destinations. Endless Fun.",
  landingBannerDetailText:
    "Embark on a Magical Journey: Discover Unlimited Thrills and Unforgettable Activities in Qatar!",
  buyTicktes: "Buy Tickets",
  addToCart: "Add to Cart",
  addMoreItems: "Add more items",
  location: "Location",
  numberOfTickets: "Number of Tickets",
  selectTickets: "Select Tickets",
  total: "Total",
  visitingHours: "Visiting Hours",
  calendarTitle: "Select Visit Date",
  calendarHelperText:
    "Relax, worried about missing the visit date? We have got you covered!",
  slotSelectionTitle: "Preferred Time Slot",
  forgotPinHeader: "Forgot Pin",
  forgotSubHeader1:
    "You will receive the OTP on both your email and mobile number.",
  forgotSubHeader: "Please enter your email to recieve a verification code",
  otpSuccessText: "Congratulations! Your pin has been successfully updated. ",
  otpErrorText: "Something went wrong,Please try again.",
  success: "Success",
  error: "Error",
  accountSuccess:
    "Congratulations! Your account has been successfully created.",
  continue: "Continue",
  tryAgain: "Try Again",
  bookingSuccess: "Booking Done Successfully",
  confirmationEmail:
    "A confirmation email will be sent shortly to your email ID with Ticket.",
  thankyouForBooking:
    "Thank you for booking your tickets! To unlock exclusive offers and discounts, sign up now. Don't miss out!",
  downloadApp: "Download the Al Maha Mobile App Today!",
  mobileDownload: "Download Our App",
  DownloadDetail:
    "Discover a world of convenience and luxury right at your fingertips. Al Maha is Qatar’s premier lifestyle app designed to make your life simpler, richer, and more enjoyable.",
  EnterCaptcha: "Enter the answer",
  DownloadFooterText: "Download Our App for discounts and offers ",
  checkoutPopupHeader: "Guest Customers",
  checkoutPopupSubHeader: "In a hurry? No problem, you can register later.",
  returningCustomerHeader: "Returning Customer",
  returningCustomerSubHeader:
    "Login to access our discount and offers to have a personalised experience",
  newTickets: "Adding new tickets to cart?",
  newTicketSubtext:
    "Some tickets are in your cart. Do you really want to discard the selection and add new tickets?",
  almahaPrompt: "Your Lifestyle Destination",
  loginPrompt:
    "Login for faster checkout and access to your saved information.",
  signupPrompt:
    "Register to access our discount and offers to have a personalised experience",
  version: "Version",
  contact: "Contact",
  book: "BOOK",
  productName: "Product Name",
  numberUnits: "Number Of Units",
  timeSlot: "Time Slots",
  requestText: "We kindly request you to arrive on time for your 60-minute slot",
  ride: "Ride",
  total: "Total",
  ticketId: "Ticket ID",
  ticketId_reservation: "Ticket ID/Reservation No",
  visitDate_time: "Visit Date and Time",
  visitDate_time2: "Visit Date & Time",
  products: "Products",
  qtyDuration: "Qty/Duration",
  status: "Status",
  action: "Action",
  ticket: "Ticket",
  duration: "Duration",
  reservation_date: "Reservation Date",
  cancelText: "Are you sure you want to cancel the ticket?",
  cancelSubText: "This action can’t be reverted and the amount will be refunded to your wallet",
  reasonTitleText: "Reason for cancelling the ticket",
  rideMap: "Ride Map",
  viewMap: "View Map",
  mapInfoTitle: "Attention Riders! 🚤🌊 ",
  mapInfoDetail: "For your safety and compliance with regulations, kindly avoid entering the marked limit on the map.These areas are restricted and legally prohibited! 🏄‍♂️ Thank you for your cooperation! 🌴",
  mapHashtagText: "#WaterSportsSafety",
  congratulations: "Congratulations",
  complementaryText: "You have just made a complimentary purchase",
  termsConditions: "TERMS & CONDITIONS APPLY",
  isPromoQuestion: "Have any Promo Code ?",
  promoCode: "Promo Code",
  //LWW Changes
  tickets: "Tickets"
};

